import { Fragment, ReactElement, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import { usePostman, createCustomContext } from '@beeline/lk-utils';

export function NavigationCore(): ReactElement {
  const postman = usePostman();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  createCustomContext({
    router: {
      navigate,
      location,
      params,
    },
  });

  useEffect(() => {
    if (postman) {
      postman.send('router', { location, params });
    }
  }, [postman, location, params]);

  return <Fragment />;
}
